import { Subject } from 'rxjs';

export class AudioRecorder {
  blobs: any[] = [];
  mediaRecorder: MediaRecorder | null = null;
  stream: MediaStream | null = null;

  audioContext: AudioContext | null = null;
  mediaStreamAudioSourceNode: MediaStreamAudioSourceNode | null = null;
  analyserNode: AnalyserNode | null = null;
  levelsInterval: any | null = null;

  level$: Subject<number> | null = null;

  async start(): Promise<MediaStream> {
    if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
      return Promise.reject(new Error('Audio recording is not supported in this browser.'));
    }

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    this.audioContext = new AudioContext();
    this.mediaStreamAudioSourceNode = this.audioContext.createMediaStreamSource(stream);
    this.analyserNode = this.audioContext.createAnalyser();
    this.mediaStreamAudioSourceNode.connect(this.analyserNode);

    this.stream = stream;
    this.mediaRecorder = new MediaRecorder(stream);
    this.blobs = [];

    this.mediaRecorder.addEventListener('dataavailable', (event: any) => {
      this.blobs.push(event.data);
    });

    this.level$ = new Subject<number>();

    this.mediaRecorder.addEventListener('start', (event: any) => {
      this.getLevel();
      this.levelsInterval = setInterval(() => {
        this.getLevel();
      }, 50);
    });

    this.mediaRecorder.start();

    return stream;
  }

  async stop(): Promise<any> {
    return new Promise((resolve) => {
      const mimeType = this.mediaRecorder!.mimeType;

      this.mediaRecorder!.addEventListener('stop', () => {
        const blob = new Blob(this.blobs, { type: mimeType });
        resolve(blob);
      });

      this.mediaRecorder!.stop();

      this.stopStream();

      clearInterval(this.levelsInterval);
      this.level$ = null;
      this.levelsInterval = null;
      this.audioContext = null;
      this.mediaStreamAudioSourceNode = null;
      this.analyserNode = null;

      //reset API properties for next recording
      this.resetRecordingProperties();
    });

    return 1;
  }

  cancel() {}

  stopStream() {
    this.stream?.getTracks().forEach((track: any) => track.stop());
  }

  resetRecordingProperties() {
    this.mediaRecorder = null;
    this.stream = null;
  }

  private getLevel() {
    if (!this.analyserNode) {
      return;
    }
    const pcmData = new Float32Array(this.analyserNode.fftSize);
    this.analyserNode.getFloatTimeDomainData(pcmData);
    let sumSquares = 0.0;
    for (const amplitude of pcmData) {
      sumSquares += amplitude * amplitude;
    }

    if (sumSquares === 0) {
      return;
    }
    const level = Math.sqrt(sumSquares / pcmData.length);
    this.level$?.next(level);
  }
}
